import { render, staticRenderFns } from "./AGCFormTags.vue?vue&type=template&id=805bd0d8&scoped=true&"
import script from "./AGCFormTags.vue?vue&type=script&lang=js&"
export * from "./AGCFormTags.vue?vue&type=script&lang=js&"
import style0 from "./AGCFormTags.vue?vue&type=style&index=0&id=805bd0d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805bd0d8",
  null
  
)

export default component.exports